import "../styles/home.scss";
import homepageHeroImg from "../images/homepage-hero.jpg";

window.onload = function loadStuff() {
  const dest = document.querySelector(".homepageHero__wrapper"),
    img = new Image();

  img.src = homepageHeroImg;
  img.onload = function () {
    dest.classList.add("homepageHero__wrapper--loaded");
    //or, to set inline use: dest.style.backgroundImage = "url(" + img + ")";
  };
};
